// 지연 로딩용 컴포넌트들 - 번들 크기 최적화
import dynamic from 'next/dynamic'
import { ComponentType } from 'react'

// 로딩 스피너 컴포넌트
const LoadingSpinner = () => (
  <div className="flex items-center justify-center p-8">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  </div>
)

// 큰 용량의 컴포넌트들을 지연 로딩으로 구현
export const LazyComponents = {
  // 채팅 관련 (큰 용량)
  ChatRoom: dynamic(() => import('./Chat/ChatRoom').then(mod => ({ default: mod.ChatRoom })), {
    loading: () => <LoadingSpinner />,
    ssr: false // 클라이언트에서만 렌더링
  }),

  // 프로필 관련
  ProfileModal: dynamic(() => import('./Profile/ProfileModal'), {
    loading: () => <LoadingSpinner />
  }),

  // ProfileEdit: dynamic(() => import('./Profile/ProfileEdit'), {
  //   loading: () => <LoadingSpinner />
  // }),

  // // 매칭 관련 (복잡한 로직)
  // MatchingForm: dynamic(() => import('./Matching/MatchingForm'), {
  //   loading: () => <LoadingSpinner />
  // }),

  // 알림 센터 (많은 기능)
  NotificationCenter: dynamic(() => import('./Notifications/NotificationCenter'), {
    loading: () => <LoadingSpinner />,
    ssr: false
  }),

  // // 관리자 패널 (대용량)
  // AdminPanel: dynamic(() => import('./Admin/AdminPanel'), {
  //   loading: () => <LoadingSpinner />,
  //   ssr: false
  // }),

  // // 통계 차트 (차트 라이브러리 포함시)
  // StatisticsChart: dynamic(() => import('./Charts/StatisticsChart'), {
  //   loading: () => <LoadingSpinner />,
  //   ssr: false
  // })
}

// 페이지 레벨 지연 로딩
// export const LazyPages = {
//   // 프로필 설정 페이지
//   ProfileSetup: dynamic(() => import('../app/profile/setup/page'), {
//     loading: () => <LoadingSpinner />
//   }),

//   // 매칭 생성 페이지
//   MatchingNew: dynamic(() => import('../app/matching/new/page'), {
//     loading: () => <LoadingSpinner />
//   }),

//   // 예약 관리 페이지
//   Reservations: dynamic(() => import('../app/reservations/page'), {
//     loading: () => <LoadingSpinner />
//   }),

//   // 관리자 페이지
//   Admin: dynamic(() => import('../app/admin/page'), {
//     loading: () => <LoadingSpinner />,
//     ssr: false
//   })
// }

// 조건부 로딩 헬퍼
export const createConditionalComponent = <T extends object>(
  importFn: () => Promise<{ default: ComponentType<T> }>,
  condition: () => boolean,
  fallback?: ComponentType<T>
) => {
  return dynamic(importFn, {
    loading: () => <LoadingSpinner />,
    ssr: false,
    // 조건이 맞지 않으면 fallback 컴포넌트 렌더링
    ...(!condition() && fallback && { default: fallback })
  })
}

// 기능별 번들 분할
// export const FeatureBundles = {
//   // 결제 관련 (PortOne SDK 포함)
//   Payment: dynamic(() => import('../features/payment'), {
//     loading: () => <LoadingSpinner />,
//     ssr: false
//   }),

//   // 매핑/지도 관련 (지도 API 포함시)
//   MapView: dynamic(() => import('../features/map'), {
//     loading: () => <LoadingSpinner />,
//     ssr: false
//   }),

//   // 파일 업로드 (복잡한 로직)
//   FileUpload: dynamic(() => import('../features/upload'), {
//     loading: () => <LoadingSpinner />,
//     ssr: false
//   }),

//   // 실시간 통신 (WebSocket 등)
//   RealTimeChat: dynamic(() => import('../features/realtime'), {
//     loading: () => <LoadingSpinner />,
//     ssr: false
//   })
// }

// 반응형 로딩 (모바일/데스크톱)
// export const ResponsiveComponents = {
//   // 모바일 전용 컴포넌트
//   MobileNav: dynamic(() => import('./Navigation/MobileNav'), {
//     loading: () => <LoadingSpinner />,
//     ssr: false
//   }),

//   // 데스크톱 전용 컴포넌트
//   DesktopNav: dynamic(() => import('./Navigation/DesktopNav'), {
//     loading: () => <LoadingSpinner />
//   })
// }

export default LazyComponents